export const NurtureIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={`${className} fill-white`}
         dangerouslySetInnerHTML={{
            __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="inherit">
        <g clip-path="url(#clip0_839_413)">
            <path d="M10.5001 18C10.3378 18 10.1799 17.9474 10.0501 17.85L7.05011 15.6C6.95696 15.5301 6.88136 15.4396 6.82929 15.3354C6.77722 15.2313 6.75011 15.1164 6.75011 15V10.785L1.48811 4.86525C1.1144 4.44366 0.870392 3.92311 0.785417 3.36618C0.700443 2.80924 0.778116 2.23961 1.0091 1.72576C1.24008 1.21191 1.61455 0.775694 2.08749 0.469549C2.56043 0.163405 3.11173 0.000355814 3.67511 0L14.3251 0C14.8884 0.000660788 15.4396 0.163979 15.9123 0.47033C16.3851 0.776681 16.7593 1.21303 16.9901 1.72694C17.2208 2.24085 17.2982 2.81046 17.213 3.36731C17.1279 3.92416 16.8837 4.44457 16.5099 4.866L11.2501 10.785V17.25C11.2501 17.4489 11.1711 17.6397 11.0304 17.7803C10.8898 17.921 10.699 18 10.5001 18Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_839_413">
            <rect width="18" height="18" fill="inherit"/>
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
